<template>
    <UModal title="CSV Import-hjelper" class="z-10" fullscreen>
        <template #body>
            <tabular-matcher :columns="cols" :data="data" @close="emit('close', true)"/>
        </template>
    </UModal>
</template>

<script setup lang="ts">
import TabularMatcher from '@/csv-transaction-importer/TabularMatcher.vue'

defineProps({
    data: String
})

const emit = defineEmits(['close'])

const cols = ['date', 'debit', 'debitVat', 'credit', 'creditVat', 'description', 'project', 'department', 'amount', 'accrAccount', 'accrStartYear', 'accrStartMonth', 'accrDuration']

</script>

<style scoped>

</style>